export default __webpack_public_path__ + "static/media/bolt.813f6bfd.svg";